// @flow

import * as React from 'react';

import { useTranslator } from '@gandi/translate';
import { Base, PillSwitch, PillSwitchPill, Svg, SrOnly } from '@gandi/ui';

import { ProductContext } from '../ProductContext';
import type { HostingPlan } from '../types';

import styles from './PlanSwitch.scss';

type Props = {
  value: HostingPlan,
  setValue: (value: HostingPlan) => void,
};

export default function PlanSwitch({
  value,
  setValue,
}: Props): React.MixedElement {
  const { __ } = useTranslator();

  const { plan, isDiscountPeriod } = React.useContext(ProductContext);

  function handleSetValue(event: SyntheticInputEvent<>): mixed {
    // $FlowFixMe[incompatible-call] is there a way to tell that the value is a HostingPlan
    setValue(event.target.value);
  }

  const annualAdvantage = isDiscountPeriod
    ? __('Black Friday: 50%% off')
    : __('2 mounths free');

  return (
    <Base flex flexCol>
      <Base
        marginBottom="xsmall"
        position="relative"
        className={styles.wrapper}
      >
        <Base
          aria-hidden
          position="absolute"
          size="small"
          transform="uppercase"
          weight="semibold"
          color={plan === 'yearly' ? 'green' : 'light'}
          className={styles.addon}
        >
          {annualAdvantage}{' '}
          {plan === 'yearly' && (
            <Svg name="miniCheckmark" className={styles.checkmark} />
          )}
        </Base>

        <PillSwitch
          value={value}
          name="plan-switch"
          className={plan === 'yearly' ? styles.pillsSelected : styles.pills}
          onChange={handleSetValue}
        >
          <PillSwitchPill value="monthly">{__('Monthly')}</PillSwitchPill>
          <PillSwitchPill value="yearly">
            {__('Yearly')} <SrOnly>{annualAdvantage}</SrOnly>
          </PillSwitchPill>
        </PillSwitch>
      </Base>
      {plan === 'monthly' ? (
        <Base tagName="p" color="light" size="small" className={styles.center}>
          {__('Pay each month. Saving a credit card is mandatory.')}
        </Base>
      ) : (
        <Base tagName="p" color="light" size="small" className={styles.center}>
          {__('Pay each year. No specific payment method required.')}
        </Base>
      )}
      <Base tagName="p" color="light" size="small" className={styles.center}>
        {__('Cancel the subscription whenever you want.')}
      </Base>
    </Base>
  );
}
